import React, { useState } from 'react';

function SizeGuide(props) {
  const [open, setOpen] = useState(false);
  const { productType } = props;

  const shirt = "Crew Neck T-Shirt";
  const hoodie = "Fleece Hoodie";
  const lscrew = "Long Sleeve Crew Neck";
  const lsfleece = "Long Sleeve Fleece Crew";

  let productSizeGuide = (productType) => {
    switch(productType) {
    case shirt:
      return (
        <tbody>
          <tr>
            <td>S<sup></sup></td>
            <td>27<sup>1/2</sup> in.</td>
            <td>19<sup></sup> in.</td>
            <td>8<sup>1/8</sup> in.</td>
          </tr>
          <tr>
            <td>M<sup></sup></td>
            <td>28<sup>1/2</sup> in.</td>
            <td>21<sup></sup> in.</td>
            <td>8<sup>3/8</sup> in.</td>
          </tr>
          <tr>
            <td>L<sup></sup></td>
            <td>29<sup>1/2</sup> in.</td>
            <td>23<sup></sup> in.</td>
            <td>8<sup>5/8</sup> in.</td>
          </tr>
          <tr>
            <td>XL<sup></sup></td>
            <td>30<sup>1/2</sup> in.</td>
            <td>25<sup></sup> in.</td>
            <td>8<sup>7/8</sup> in.</td>
          </tr>
          <tr>
            <td>XXL<sup></sup></td>
            <td>31<sup>1/2</sup> in.</td>
            <td>27<sup></sup> in.</td>
            <td>9<sup>1/8</sup> in.</td>
          </tr>
        </tbody>
      )
    case hoodie:
      return (
        <tbody>
          <tr>
            <td>S<sup></sup></td>
            <td>26<sup>7/8</sup> in.</td>
            <td>20<sup>1/2</sup> in.</td>
            <td>23<sup>7/8</sup> in.</td>
          </tr>
          <tr>
            <td>M<sup></sup></td>
            <td>28<sup>1/8</sup> in.</td>
            <td>22<sup>1/2</sup> in.</td>
            <td>24<sup>7/8</sup> in.</td>
          </tr>
          <tr>
            <td>L<sup></sup></td>
            <td>29<sup>1/4</sup> in.</td>
            <td>24<sup>1/2</sup> in.</td>
            <td>24<sup>7/8</sup> in.</td>
          </tr>
          <tr>
            <td>XL<sup></sup></td>
            <td>30<sup>3/8</sup> in.</td>
            <td>26<sup>1/2</sup> in.</td>
            <td>25<sup>7/8</sup> in.</td>
          </tr>
          <tr>
            <td>XXL<sup></sup></td>
            <td>31<sup>1/2</sup> in.</td>
            <td>28<sup>1/2</sup> in.</td>
            <td>25<sup>7/8</sup> in.</td>
          </tr>
        </tbody>
      )
    case lscrew:
      return (
        <tbody>
          <tr>
            <td>S<sup></sup></td>
            <td>27<sup>1/2</sup> in.</td>
            <td>19<sup></sup> in.</td>
            <td>24<sup>1/4</sup> in.</td>
          </tr>
          <tr>
            <td>M<sup></sup></td>
            <td>28<sup>1/2</sup> in.</td>
            <td>21<sup></sup> in.</td>
            <td>24<sup>5/8</sup> in.</td>
          </tr>
          <tr>
            <td>L<sup></sup></td>
            <td>29<sup>1/2</sup> in.</td>
            <td>23<sup></sup> in.</td>
            <td>24<sup>7/8</sup> in.</td>
          </tr>
          <tr>
            <td>XL<sup></sup></td>
            <td>30<sup>5/8</sup> in.</td>
            <td>25<sup></sup> in.</td>
            <td>25<sup>1/8</sup> in.</td>
          </tr>
          <tr>
            <td>XXL<sup></sup></td>
            <td>31<sup>5/8</sup> in.</td>
            <td>27<sup></sup> in.</td>
            <td>25<sup>3/8</sup> in.</td>
          </tr>
        </tbody>
      )
    case lsfleece:
      return (
        <tbody>
          <tr>
            <td>S<sup></sup></td>
            <td>28<sup>1/4</sup> in.</td>
            <td>20<sup>3/8</sup> in.</td>
            <td>24<sup>1/8</sup> in.</td>
          </tr>
          <tr>
            <td>M<sup></sup></td>
            <td>28<sup>3/8</sup> in.</td>
            <td>22<sup>3/8</sup> in.</td>
            <td>24<sup>5/8</sup> in.</td>
          </tr>
          <tr>
            <td>L<sup></sup></td>
            <td>28<sup>1/2</sup> in.</td>
            <td>24<sup>3/8</sup> in.</td>
            <td>25<sup>1/8</sup> in.</td>
          </tr>
          <tr>
            <td>XL<sup></sup></td>
            <td>28<sup>5/8</sup> in.</td>
            <td>26<sup>3/8</sup> in.</td>
            <td>25<sup>5/8</sup> in.</td>
          </tr>
          <tr>
            <td>XXL<sup></sup></td>
            <td>28<sup>3/4</sup> in.</td>
            <td>28<sup>3/8</sup> in.</td>
            <td>26<sup>1/8</sup> in.</td>
          </tr>
        </tbody>
      )
    default:
      return (<tbody></tbody>)
    }
  }

  return (
    <div className="Size_Guide">
      <span className="Size_Guide__button" onClick={() => setOpen(!open)}>
        View Size Guide
      </span>
      <div hidden={!open}>
        <h2>SIZE GUIDE</h2>
        <table>
          <thead>
            <tr>
              <td></td>
              <td>BODY LENGTH</td>
              <td>CHEST WIDTH</td>
              <td>SLEEVE LENGTH</td>
            </tr>
          </thead>
          {productSizeGuide(productType)}
        </table>
      </div>
    </div>
  );
}

export default SizeGuide;
